import request from '@/utils/request'

// 基金会事件
export function incidentAll (data) {
  return request({
    url: `/api/getFoundationIncidentAll`,
    method: 'POST',
    data
  })
}
// 基金会信息
export function foundationOne (params) {
  return request({
    url: `/api/getFoundationOne`,
    method: 'GET',
    params
  })
}
// 项目分页
export function projectAllPage (data) {
  return request({
    url: `/api/getInvestmentProjectAllPage`,
    method: 'POST',
    data
  })
}
// 项目推荐
export function projectTment (params) {
  return request({
    url: `/api/getInvestmentProjectList`,
    method: 'GET',
    params
  })
}
// 合作伙伴全部
export function partnerAll (data) {
  return request({
    url: `/api/getPartnerAll`,
    method: 'POST',
    data
  })
}
// 新闻中心推荐
export function pressCenter (params) {
  return request({
    url: `/api/getPressCenter`,
    method: 'GET',
    params
  })
}
// 新闻中心全部分页
export function pressCenterAllPage (data) {
  return request({
    url: `/api/getPressCenterAllPage`,
    method: 'POST',
    data
  })
}
// 人才招聘全部分页
export function recruitmentAllPage (data) {
  return request({
    url: `/api/getTalentRecruitmentAllPage`,
    method: 'POST',
    data
  })
}
// 获取网站配置
export function configOne (params) {
  return request({
    url: `/api/getWebsiteConfigOne`,
    method: 'GET',
    params
  })
}
// 获取投资项目详情
export function projectInfo (params) {
  return request({
    url: `/api/getInvestmentProjectOne`,
    method: 'GET',
    params
  })
}
// 获取新闻详情
export function newInfo (params) {
  return request({
    url: `/api/getPressCenterOne`,
    method: 'GET',
    params
  })
}
// 上传
export function upload (data) {
  return request({
    url: `/upload`,
    method: 'post',
    data,
    headers: {
      'Content-Type': 'multipart/form-data'
    }
  })
}
